module.exports = __webpack_public_path__ + "img/y-203.83610d51.png";